export const JACKPOT_WIDGET = 'daily-jackpot';
export const RED_TIGER_JACKPOT = 'red-tiger-jackpot';